import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { getIsShortStatus, getStatusBackgroundProps, styleFromWidthHeight, getTextDumboTypeBySize, } from '../../_helpers';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import Background from '../../../Background';
import s from './Status.scss';
export var StatusDumbView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, className = _a.className, ariaHidden = _a["aria-hidden"], _b = _a.responsive, responsive = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var textContent = deviation.textContent;
    if (!textContent) {
        return null;
    }
    var type = getTextDumboTypeBySize(height || width);
    var style = styleFromWidthHeight({ width: width, height: height }, responsive);
    var backgroundProps = getStatusBackgroundProps(deviation);
    return (React.createElement(Section, { style: style },
        React.createElement(Background, __assign({ className: classnames(s['root'], s[type], getIsShortStatus(deviation, true) ? s['short'] : s['long'], className), contentClassName: s["content-" + type], width: width, height: height, variant: "status" }, backgroundProps),
            React.createElement("div", { className: s['body'], "aria-hidden": ariaHidden },
                React.createElement(ExcerptRenderer, { className: s['body-inner'], textContent: textContent, htmlExcerptLegacy: true, emptyPlaceHolder: "[" + t('deviationview.unknown.nopreview') + "]" })))));
};
StatusDumbView.displayName = 'StatusDumbView';
export default StatusDumbView;
//# sourceMappingURL=Status.js.map